import React from "react";
import Modal from "react-bootstrap/Modal";

require("./assets/css/Video.css");

const VideoClientDetailModal = ({ show, onHide, client }) => {
    if (!client) return null;

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStatusBadge = (status) => {
        const badges = {
            waiting: { class: 'bg-secondary', text: 'Aguardando' },
            in_queue: { class: 'bg-warning', text: 'Na Fila' },
            in_progress: { class: 'bg-success', text: 'Em Atendimento' },
            completed: { class: 'bg-info', text: 'Finalizado' },
            cancelled: { class: 'bg-danger', text: 'Cancelado' },
            no_show: { class: 'bg-dark', text: 'Não Compareceu' }
        };

        const badge = badges[status] || badges.waiting;

        return (
            <span className={`badge ${badge.class}`}>
                {badge.text}
            </span>
        );
    };

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-user me-2"></i>
                    Detalhes do Cliente
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    {/* Client Info */}
                    <div className="col-md-12">
                        <div className="video-info-card mb-3">
                            <div className="d-flex align-items-center mb-3">
                                <div className="video-user-avatar me-3" style={{ width: '60px', height: '60px', fontSize: '1.5rem' }}>
                                    {client.name?.charAt(0)?.toUpperCase() || 'C'}
                                </div>
                                <div>
                                    <h5 className="mb-1">{client.name || 'Cliente'}</h5>
                                    <p className="text-muted mb-0">
                                        Cadastrado em: {formatDate(client.created_at)}
                                    </p>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <table className="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted" width="30%">E-mail:</td>
                                                <td>{client.email || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Telefone:</td>
                                                <td>{client.phone || '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-6">
                                    <table className="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted" width="40%">Total de Atendimentos:</td>
                                                <td>
                                                    <span className="badge bg-info">
                                                        {client.attendances_count || client.attendances?.length || 0}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Attendances History */}
                    {client.attendances && client.attendances.length > 0 && (
                        <div className="col-md-12">
                            <div className="video-info-card">
                                <h6 className="text-muted mb-3">
                                    <i className="fa fa-history me-2"></i>
                                    Histórico de Atendimentos
                                </h6>
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Protocolo</th>
                                                <th>Data</th>
                                                <th>Departamento</th>
                                                <th>Status</th>
                                                <th>Atendente</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {client.attendances.map((attendance) => (
                                                <tr key={attendance.id}>
                                                    <td>
                                                        <code>{attendance.protocol}</code>
                                                    </td>
                                                    <td>{formatDate(attendance.created_at)}</td>
                                                    <td>{attendance.department?.name || '-'}</td>
                                                    <td>{getStatusBadge(attendance.status)}</td>
                                                    <td>{attendance.professional?.name || '-'}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {(!client.attendances || client.attendances.length === 0) && (
                        <div className="col-md-12">
                            <div className="video-info-card text-center py-4">
                                <i className="fa fa-inbox fa-2x text-muted mb-2"></i>
                                <p className="text-muted mb-0">Nenhum atendimento registrado</p>
                            </div>
                        </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={onHide}>
                    <i className="fa fa-times me-2"></i>
                    Fechar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default VideoClientDetailModal;
